$(function () {
  if ($("#change-password-modal").length > 0) {
    $("#change-password-modal").modal("show");
  }
});
